import { render, staticRenderFns } from "./Orderinfo.vue?vue&type=template&id=f3a213d4&scoped=true&"
import script from "./Orderinfo.vue?vue&type=script&lang=js&"
export * from "./Orderinfo.vue?vue&type=script&lang=js&"
import style0 from "./Orderinfo.vue?vue&type=style&index=0&id=f3a213d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a213d4",
  null
  
)

export default component.exports